<template>
  <div
    :key="key"
    :class="['notificacao-container', { 'padding-com-checkbox': paddingComCheckBox }]"
  >
    <div :class="['notificacao-cabecalho', tipo]">
      <i v-if="tipo == 'aplicabilidade' || tipo == 'alerta'" class="fa fa-check-circle" />
      <i v-if="tipo == 'inaplicabilidade'" class="fa fa-exclamation-triangle" />
      <i v-if="tipo == 'nota'" class="fa fa-clipboard" />
      <span>{{ titulo }}</span>
    </div>
    <div :class="['notificacao-corpo', { negrito: negrito }]">
      <p v-html="mensagem" />
      <div v-if="cnae" class="cnae-container">
        <p :class="[tipo, 'sem-quebra']">Estabelecimentos enquadrados nas CNAEs:</p>
        <p>{{ cnae }}</p>
      </div>
      <Cabecalho
        municipios
        tipo="alerta"
        paddingAlerta
        :class="['cabecalho']"
        v-if="municipios"
        :titulo="'Aplicável aos Municípios:'"
        :aliquota="municipios"
      />
      <BaseLegal class="base-nota" v-if="baseLegal" :base_legal="baseLegal" :classe="classe" />
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import stringFormatMixin from "@/mixins/stringFormatMixin";

export default {
  name: "Notificacao",
  mixins: [stringFormatMixin],
  components: {
    Cabecalho,
    BaseLegal
  },
  props: {
    paddingComCheckBox: Boolean,
    tipo: String,
    texto: String,
    negrito: Boolean,
    cnae: String,
    municipios: String,
    baseLegal: String,
    classe: String
  },

  data() {
    return {
      key: 0
    };
  },

  watch: {
    tipo() {
      this.key += 1;
    }
  },

  computed: {
    titulo: function() {
      let titulo = this.tipo == "revisao" ? "NCM SOB REVISÃO" : this.tipo.toUpperCase();

      return titulo;
    },

    mensagem: function() {
      let mensagem =
        this.tipo == "revisao"
          ? '<strong>Atenção:</strong> esse código NCM foi modificado em decorrência da aprovação da nova NCM pela <a target="_blank" href="http://www.econeteditora.com.br/?url=bdi/in/21/in_rfb_2054_2021.php">IN RFB n° 2.054/2021</a>, e encontra-se em revisão em nosso sistema.'
          : this.strReplace(this.texto, "<a ", "<a target='_blank' ");

      return mensagem;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.notificacao-container {
  margin: 1rem 0;
}

.notificacao-cabecalho {
  display: flex;
  align-items: center;
  background-color: var(--branco);
  gap: 0.2rem;
  width: fit-content;
  padding: 0.5rem;

  span {
    font-size: 1rem;
  }
}

.notificacao-corpo {
  padding: 0.725rem 1.5rem;
  background-color: var(--branco);
  text-align: justify;

  p {
    margin-bottom: 0;
  }
}

.aplicabilidade {
  color: #207a23;
}

.alerta {
  color: #f1925c;
}

.inaplicabilidade {
  color: #bc2c2c;
}
.observação {
  span {
    font-weight: 600;
  }
}

.revisao {
  color: #cbce11;
}

.negrito {
  font-weight: bold;
}

.cnae-container {
  display: flex;
  margin-top: 1rem;
}
.sem-quebra {
  white-space: nowrap;
  margin-right: 5px;
}
.nota {
  color: #1884b1;
}
.padding-com-checkbox {
  margin-left: 24px;
}

.base-nota {
  padding-top: 10px;
}

@media only print {
  .notificacao-container {
    border: 1px solid var(--print-borda);
    margin: 1rem 0 !important;
  }
  .notificacao-cabecalho,
  .notificacao-corpo {
    color: var(--preto);
    background: transparent;
    padding-left: 1rem;
  }
  .notificacao-corpo {
    padding-top: 0;
  }
  .aplicabilidade {
    color: var(--preto);
  }
}
</style>
